import React from 'react';

import { CancelConfirmProps } from 'types';
import Button from 'components/Button/Button';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const CancelConfirm: React.FC<CancelConfirmProps & ComponentProps> = ({ callback, styles, closeModal }) => {
  return (
    <div data-testid="cancel-confirm" role="dialog" aria-labelledby="cancel-confirmation-title">
      <h2 id="cancel-confirm-title" className={styles.NoMargin} style={{ marginBottom: '60px' }}>
        Do you want to cancel without updating?
      </h2>
      <div className={styles.ButtonRow}>
        <Button onClick={closeModal} level="low">
          <span>No</span>
        </Button>
        <Button
          onClick={() => {
            callback();
            closeModal();
          }}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default CancelConfirm;
